import { useClient } from "../api/clients";
import type { ClientListItem } from "../api/types";

// Whether the signed-in user may edit this client (owner or maintainer). The
// role comes from the full client record, the same source the client settings
// page uses; the list item's role is only the fallback while that loads.
export function useCanEditClient(client: ClientListItem): boolean {
  const { data: detail } = useClient(client.id);
  const role = detail?.userRole ?? client.userRole;
  return role === "owner" || role === "maintainer";
}

// Whether the signed-in user may manage this client, which takes ownership:
// deleting it and changing its type are owner-only, as on the client page.
export function useCanManageClient(client: ClientListItem): boolean {
  const { data: detail } = useClient(client.id);
  return (detail?.userRole ?? client.userRole) === "owner";
}
